var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TimePicker',{attrs:{"value":_vm.innervalue,"format":"HH:mm","type":"timerange","placement":"bottom-end","placeholder":"请选择时间段"},on:{"on-change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }